<template>
  <div class="button" :class="trailerClass">
    <img v-if="!trailer" class="subscribe_icon" src="../../../../static/subscribe.svg" />
    {{ trailer ? '已订阅' : '订阅' }}
  </div>
</template>

<script>
export default {
  name: 'TrailerButton',
  props: {
    trailer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    trailerClass: function() {
      return this.trailer ? 'button-subscribed' : 'button-subscribe';
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "../../../share/mixins.styl"
  .button-subscribed
    background-image url('../../../../static/subscribed.png')
    color #ADADAF
  .button-subscribe
    background-image url('../../../../static/subscribe.png')
    color #CB8723
  .button
    margin 0 auto
    width 1.2rem;
    height .48rem;
    // background linear-gradient(90deg,rgba(254,220,156,1) 0%,rgba(255,198,99,1) 100%);
    background-repeat no-repeat
    background-size contain
    // border-radius .27rem;
    text-align center
    line-height @height
    font-size .24rem
    font-weight 600
    display flex
    justify-content center
    align-items center
    @media screen and (min-width: 700px)
      font-size 16PX
      line-height: 16PX
    .subscribe_icon
      display block
      height .3rem
      margin-right .08rem
      @media screen and (min-width: 700px)
        height 20PX
</style>
